import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import { Box, Checkbox, Collapse, FormControlLabel, IconButton, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import T from 'T'

const InheritBillingProfileCheckbox = ({ checked = true, onChange = noop, billingProfileName = '', children }) => {
  const [expanded, setExpanded] = useState(false)

  const handleToggleExpand = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    setExpanded(prev => !prev)
  }, [])

  const handleMouseDown = useCallback(event => {
    event.stopPropagation()
  }, [])

  const hasExpandableContent = Boolean(children && billingProfileName)

  return (
    <Box sx={{ mb: 2 }}>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={onChange} size="small" />}
        label={
          <Box>
            <Typography variant="body1">{T.INHERIT_CHANGES_FROM_BILLING_PROFILE}</Typography>
            {billingProfileName && (
              <Box display="flex" alignItems="center">
                <Typography variant="body2" color="primary">
                  {billingProfileName}
                </Typography>
                {hasExpandableContent && (
                  <IconButton
                    size="small"
                    onClick={handleToggleExpand}
                    onMouseDown={handleMouseDown}
                    aria-label={expanded ? 'Collapse billing profile details' : 'Expand billing profile details'}
                    aria-expanded={expanded}
                    aria-controls="billing-profile-details"
                    sx={{
                      ml: 0.5,
                      p: 0.25,
                      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }}
                  >
                    <ExpandMoreIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            )}
          </Box>
        }
      />
      {hasExpandableContent && (
        <Collapse in={expanded}>
          <Box id="billing-profile-details" sx={{ ml: 4, mt: 1, p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
            {children}
          </Box>
        </Collapse>
      )}
    </Box>
  )
}

InheritBillingProfileCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  billingProfileName: PropTypes.string,
  children: PropTypes.node,
}

export default InheritBillingProfileCheckbox
